<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <template v-if="!form">
                <vue-headful :title="'New Entry [Custom Form] :: MeritEHS'"/>

                <h4 class="py-3 mb-4">
                    <ol class="breadcrumb font-weight-bold m-0">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/custom-forms`">
                                <i class="fa fa-file-text"></i> Custom Forms
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active">
                            New Entry
                        </li>
                    </ol>
                </h4>

                <div class="row mb-4">
                    <div class="col-xl-4 col-lg-5 col-12">
                        <div class="card mb-3">
                            <div class="card-header">
                                Select a Custom Form: <i class="fa fa-asterisk text-danger"></i>
                            </div>
                            <div class="card-body">
                                <b-form-select v-model="covid_form_id" :options="formOptions" @change="getCreate(covid_form_id)"></b-form-select>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <vue-headful :title="form.covid_form_name+' [Custom Form] :: MeritEHS'"/>

                <h4 class="py-3 mb-4">
                    <ol class="breadcrumb font-weight-bold m-0">
                        <li class="breadcrumb-item font-weight-light">
                            <router-link :to="`/custom-forms`">
                                <i class="fa fa-file-text"></i> Custom Forms
                            </router-link>
                        </li>
                        <template v-if="entry.id">
                            <li class="breadcrumb-item font-weight-light">
                                <router-link :to="`/custom-forms/entry/view/${entry.id}`">
                                    {{ entry.covid_form_name }} -
                                    <template v-if="entry.employee_id">
                                        {{ entry.FirstName }} {{ entry.LastName }}
                                    </template>
                                    <template v-else>
                                        {{ entry.person_name }}
                                    </template>
                                    - {{ entry.created_at | moment("MM/DD/YYYY") }}
                                </router-link>
                            </li>
                            <li class="breadcrumb-item active">
                                Edit
                            </li>
                        </template>
                        <template v-else>
                            <li class="breadcrumb-item active">
                                New Entry - {{ form.covid_form_name }}
                            </li>
                        </template>

                    </ol>
                </h4>

                <h4 class="mt-4 ">{{ form.covid_form_name }}</h4>

                <div class="row">
                    <div class="col-xl-9 col-lg-12">
                        <personnel-form ref="customFormPersonnelForm" :initialPersonnel="personnel" />

                        <covid-fields
                            ref="covidFields"
                            :sections="covidSections"
                            :initialValues="customFieldValues"
                            @customFieldsChanged="setFields"
                            :errors="errors"
                            labelSize="col-lg-3 col-md-4 col-12 text-md-right text-muted"
                            fieldSize="col-lg-6 col-md-8 col-12" />

                        <div class="card mb-3">
                            <div class="card-header">
                                <strong>Date, Location<span v-if="form.require_employee_sig">, and Sign</span>:</strong>
                            </div>
                            <div class="card-body">
                                <div class="row mb-3">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right text-muted">Date:</div>
                                    <div class="col-lg-6 col-md-8 col-12">
                                        <strong>{{ now }}</strong>
                                    </div>
                                </div>
                                <div class="row mb-4">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-muted': !errors.jobsite_id, 'text-danger': errors.jobsite_id}">
                                        Jobsite: <i class="fa fa-asterisk text-danger" v-if="form.require_jobsite"></i>
                                    </div>
                                    <div class="col-lg-6 col-md-8 col-12">
                                        <jobsite-select ref="jobsiteSelector" :selectedValues="JobsiteValues" @vselected="onJobSiteSelectUpdate" :hasError="errors.jobsite_id ? true : false"></jobsite-select>

                                        <div class="text-danger mt-2" v-if="errors.jobsite_id">
                                            <ul>
                                                <li v-for="err in errors.jobsite_id">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-3">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-muted': !errors.person_or_employee, 'text-danger': errors.person_or_employee}">Employee Or Guest: <i class="fa fa-asterisk text-danger"></i></div>
                                    <div class="col-lg-6 col-md-8 col-12">
                                        <b-form-radio-group v-model="entry.person_or_employee" :options="[{text: 'Employee', value: 'Employee'}, {text: 'Guest', value: 'Visitor'}]" plain></b-form-radio-group>

                                        <div class="text-danger mt-2" v-if="errors.person_or_employee">
                                            <ul>
                                                <li v-for="err in errors.person_or_employee">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4" v-if="entry.person_or_employee == 'Visitor'">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-muted': !errors.person_name, 'text-danger': errors.person_name}">Guest: <i class="fa fa-asterisk text-danger"></i></div>
                                    <div class="col-lg-6 col-md-8 col-12">
                                        <b-form-input v-model="entry.person_name" placeholder="Enter Guest Name" :class="{'is-invalid': errors.person_name}"></b-form-input>

                                        <div class="text-danger mt-2" v-if="errors.person_name">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.person_name">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="row mb-4" v-if="entry.person_or_employee == 'Employee'">
                                    <div class="col-lg-3 col-md-4 col-12 text-md-right" :class="{'text-muted': !errors.employee_id, 'text-danger': errors.employee_id}">Employee: <i class="fa fa-asterisk text-danger"></i></div>
                                    <div class="col-lg-6 col-md-8 col-12">
                                        <employee-select ref="employeeSelector" :selectedValues="EmployeeValues" @vselected="onEmployeeSelect" :hasError="errors.employee_id ? true : false"></employee-select>

                                        <div class="text-danger mt-2" v-if="errors.employee_id">
                                            <ul class="list-unstyled">
                                                <li v-for="err in errors.employee_id">{{ err }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="form.require_employee_sig && !entry.signature_file_id">
                                    <label :class="{'text-danger': errors.signature_data}">
                                        Signature: <i class="fa fa-asterisk text-danger"></i>
                                    </label>
                                    <span class="text-danger" v-if="errors.signature_data">
                                        <span v-for="(err, i) in errors.signature_data"><template v-if="i > 0">. </template>{{ err }}</span>
                                    </span>
                                    <VueSignaturePad ref="sigPad" class="signature-pad" />
                                </div>
                                <div v-else-if="entry.signature_file_id">
                                    <img ref="signatureFile" src="" class="img-fluid" />
                                </div>

                            </div>
                            <div class="card-footer">
                                <button class="btn btn-success" v-on:click="saveEntry()" :disabled="saving">
                                    <template v-if="saving"><i class="fa fa-spinner fa-spin"></i> Saving...</template>
                                    <template v-else>Complete Form</template>
                                </button>
                                <b-form-checkbox v-model="create_new_entry" :value="true" :unchecked-value="false" plain class="mt-2">Complete Another?</b-form-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<style type="text/css">
    .signature-pad {
        width: 100%;
        height: 300px;
        border: 1px solid #ddd;
    }
</style>

<script>
    import moment from 'moment-timezone';

    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                create_new_entry: false,
                id: this.$route.params.id,
                form: null,
                now: moment().tz(this.$store.state.user.timezone).format('MM/DD/YYYY hh:mm a'),
                allForms: [],
                covid_form_id: null,
                covid_fields: [],
                covid_field_values: [],
                personnel: [],
                entry: {},
                errors: {},
            }
        },

        watch: {

            // covid_form_id(newVal, oldVal){
            //     //set the form
            //     for (var i = this.allForms.length - 1; i >= 0; i--)
            //     {
            //         if(this.allForms[i].id === parseInt(newVal))
            //         {
            //             //Set the form
            //             this.form = this.allForms[i];

            //             //Set the entry
            //             this.entry.covid_form_id = this.allForms[i].id;

            //             //Check if we need to decod
            //             if(typeof this.allForms[i].covid_fields == 'string')
            //             {
            //                 this.covid_fields = JSON.parse(this.allForms[i].covid_fields);
            //             }
            //             else
            //             {
            //                 this.covid_fields = this.allForms[i].covid_fields;
            //             }

            //         }
            //     }
            // }
        },

        computed: {
            covidSections(){
                //Setup
                var covid_fields = [];

                //Loop through and build lists
                for(var i = 0; i < this.covid_fields.length; i++)
                {
                    //Close it
                    var sec = JSON.parse(JSON.stringify(this.covid_fields[i]));

                    //Unset the base section
                    delete sec.base_section;

                    //Push onto options
                    covid_fields.push(sec);
                }

                //Send it
                return covid_fields;
            },

            customFieldValues(){
                //Setup
                var values = {};

                //Loop
                for (var i = 0; i < this.covid_fields.length; i++)
                {
                    //Append
                    for (var j = 0; j < this.covid_fields[i].fields.length; j++)
                    {
                        //Parse Some Stuff
                        switch(this.covid_fields[i].fields[j].type)
                        {
                            default:
                                //Setup
                                values[this.covid_fields[i].fields[j].id] = this.covid_fields[i].fields[j].value;
                                break;
                        }
                    }
                }

                return values;
            },

            customFieldFileTypes(){
                //Loop and build
                var fields = [];

                //Main Loop
                for (var i = 0; i < this.covid_fields.length; i++)
                {
                    //Loop Through all the field
                    for (var j = 0; j < this.covid_fields[i].fields.length; j++)
                    {
                        //Check it
                        if(this.covid_fields[i].fields[j].type == 'File')
                        {
                            fields.push(this.covid_fields[i].fields[j]);
                        }
                    }
                }

                //Send it
                return fields;
            },

            formOptions(){
                //Send it
                var options = [{value: null, text: '-- Select a Form --'}];

                //Build
                for (var i = this.allForms.length - 1; i >= 0; i--)
                {
                    options.push({value: this.allForms[i].id, text: this.allForms[i].covid_form_name});
                }

                return options;
            },

            EmployeeValues(){
                //check for null
                if(!this.entry.employee_id)
                {
                    return {};
                }

                return {EmployeeId: this.entry.employee_id, FirstName: this.entry.FirstName, LastName: this.entry.LastName, EmployeeNumber: this.entry.EmployeeNumber};
            },

            JobsiteValues(){
                //check for null
                if(!this.entry.jobsite_id)
                {
                    return {};
                }

                return {JobsiteId: this.entry.jobsite_id, JobsiteNumber: this.entry.JobsiteNumber, JobsiteName: this.entry.JobsiteName};
            },
        },

        methods: {

            init(){
                //If there was an ID, call it
                if(this.id)
                {
                    this.getEdit();
                }
                else
                {
                    this.getCreate();
                }
            },

            getCreate(load_form_id = null){
                //Loading
                this.loading = true;

                //Setup
                var params = this.$route.query;

                //Check if
                if(load_form_id)
                {
                    params['form_id'] = load_form_id;
                }

                //Get the data
                this.$http
                    .get('/custom-forms/entry/create', params)
                    .then(response => {
                        //Set all the data
                        this.allForms = response.data.allForms;
                        //this.entry = response.data.entry;

                        //Check if we received a form and personnel
                        if(response.data.form)
                        {
                            //set it
                            this.form = response.data.form;

                            //Set it
                            this.entry.covid_form_id = this.form.id;

                            //Now we can set and build the form and the personnel
                            this.covid_fields = JSON.parse(this.form.covid_fields);

                            //Set personnel
                            this.personnel = response.data.personnel;
                        }
                    })
                    .catch(response => {
                        //Set
                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;

                        //Set here because the component has rendered. This will fail inside the first THEN
                        //this.$refs.customFormPersonnelForm.setPersonnel(this.personnel);
                    });
            },

            getEdit() {
                //Get the data
                this.$http
                    .get('/custom-forms/entry/edit/' + this.id, this.$route.query)
                    .then(response => {
                        //Set all the data
                        this.entry = response.data.entry;
                        this.form = response.data.form;

                        //Get the personnel
                        this.personnel = response.data.personnel;
                        //this.$refs.customFormPersonnelForm.setPersonnel(response.data.personnel);

                        //Set the fields
                        this.covid_fields = JSON.parse(this.entry.covid_fields);

                        //Load the sig
                        if(this.entry.signature_file_id)
                        {
                            //Load it
                            this.loadSignature(this.entry.signature_file_id);
                        }

                        //Set the helper
                        if(this.entry.employee_id)
                        {
                            this.entry.person_or_employee = 'Employee';
                        }
                        else if (this.entry.person_name)
                        {
                            this.entry.person_or_employee = 'Visitor';
                        }
                    })
                    .catch(response => {
                        //Set
                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;

                        //Set here because the component has rendered. This will fail inside the first THEN
                        //this.$refs.customFormPersonnelForm.setPersonnel(this.personnel);
                    });
            },

            saveEntry() {
                //Helpers
                this.saving = true;

                //Set the fields
                this.entry.covid_field_values = this.covid_field_values;
                this.entry.personnel = this.$refs.customFormPersonnelForm.getPersonnel();

                //Set the Signature
                if(this.form.require_employee_sig == 1 && !this.entry.signature_file_id)
                {
                    //This returns a boolean and a data:image stream.
                    //Is empty is wether or not the signature is populated.
                    const { isEmpty, data } = this.$refs['sigPad'].saveSignature();

                    //Set the Data
                    this.entry.signature_data = isEmpty ? null : data;
                }

                //Build the custom field Files
                var files = {};

                //Loop and Build
                for (var i = this.customFieldFileTypes.length - 1; i >= 0; i--)
                {
                    //Push onto the fields
                    if( this.entry.covid_field_values[this.customFieldFileTypes[i].id] )
                    {
                        //Check for Array
                        if( Array.isArray(this.entry.covid_field_values[this.customFieldFileTypes[i].id]) )
                        {
                            //Append Each
                            files['custom_field_file_'+this.customFieldFileTypes[i].id] = [];

                            //Loop and Build
                            for (var j = 0; j < this.entry.covid_field_values[this.customFieldFileTypes[i].id].length; j++)
                            {
                                //Push onto array
                                files['custom_field_file_'+this.customFieldFileTypes[i].id].push(this.entry.covid_field_values[this.customFieldFileTypes[i].id][j]);
                            }
                        }
                        else
                        {
                            //Set the field type
                            files['custom_field_file_'+this.customFieldFileTypes[i].id] = this.entry.covid_field_values[this.customFieldFileTypes[i].id];
                        }
                    }
                }

                //Get the data
                this.$http
                    .postWithFiles('/custom-forms/entry/edit', this.entry, files)
                    .then(response => {
                        //ALert
                        this.$toastr.success('Form Entry Saved');

                        //Send to view
                        if(this.create_new_entry)
                        {
                            //Rload the location
                            this.$router.go('/custom-forms/entry/create');
                        }
                        else
                        {
                            this.$router.push('/custom-forms/entry/view/'+response.data.id);
                        }

                    })
                    .catch(error => {
                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data.errors;

                            //Set the errors
                            this.$refs.customFormPersonnelForm.setErrors(this.errors);
                        }
                        else
                        {
                            //Alert the user
                            this.$toastr.error(error.response.data, 'Failed to Save Custom Form Entry');
                        }
                    })
                    .then(() => {
                        //Set loading
                        this.saving = false;
                    });
            },

            loadSignature(signature_file_id){
                //Send it
                this.$http.get('files/view/'+signature_file_id, {display_type: 'fluid'})
                    .then(response => {
                        //Sent the ref
                        this.$refs.signatureFile.src = response.data;
                    })
                    .catch(err => {
                        switch(err.status)
                        {
                            case 410:
                                //Stop here?
                                //this.$refs['file-' + file.file_id][0].src = '/Images/file-not-found.png';
                                break;
                        }
                    });

                //Need to return null so it fills the source
                return null;
            },

            setFields(fields){
                //Set it
                this.covid_field_values = fields;
            },

            onEmployeeSelect(employee){
                if (employee == null)
                {
                    //SEt the employee
                    this.entry.employee_id = null;

                    //Clear the signature
                    this.entry.signature_file_id = null;

                    //Stop here
                    return;
                }

                //Set
                this.entry.employee_id = employee.EmployeeId;

                //Clear the signature
                this.entry.signature_file_id = null;
            },

            onJobSiteSelectUpdate (selected) {
                if (selected == null)
                {
                    this.entry.jobsite_id = null;

                    //Stop here
                    return;
                }

                //Set it
                this.entry.jobsite_id = selected['JobsiteId'];
            },

        },

        mounted() {
            //Get the Safety Meeting
            this.init();
        }
    }
</script>
